// The other applications the server hosts, offered by the login page's application picker
// (backend GET /api/auth/server-apps). Prod and KSA host none, so the picker stays hidden there.

export interface ServerApp {
    id: string;
    name: string;
    /** The application's own page, where the user signs in. */
    url: string;
    /** False while it does not answer: listed, greyed out, as not responding. */
    available: boolean;
}

/** The answer's applications that open somewhere other than this page: http(s) links with a name, once each. */
export function otherServerApps(apps: unknown, currentOrigin: string): ServerApp[] {
    if (!Array.isArray(apps)) return [];
    const out: ServerApp[] = [];
    const seen = new Set<string>();
    for (const raw of apps) {
        if (!raw || typeof raw !== 'object') continue;
        const { id, name, url, available } = raw as Record<string, unknown>;
        if (typeof id !== 'string' || !id || typeof name !== 'string' || !name.trim() || typeof url !== 'string') continue;
        let parsed: URL;
        try {
            parsed = new URL(url);
        } catch {
            continue;
        }
        if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') continue;
        if (parsed.origin === currentOrigin || seen.has(id)) continue;
        seen.add(id);
        out.push({ id, name: name.trim(), url: parsed.href, available: available !== false });
    }
    return out;
}

/** "prpo.al-dhow.com:8443": where an application lives, for the picker's second line. */
export function appAddress(url: string): string {
    try {
        return new URL(url).host;
    } catch {
        return url;
    }
}
